<template>
  <div>
    <!-- Filter Section -->
    <div class="mb-1">
      <div class="relative w-full">
        <select
            v-model="selectedFilter"
            class="appearance-none w-full bg-transparent text-primary text-base rounded-md pl-0 pr-8 py-2 focus:outline-none cursor-pointer"
        >
          <option value="all">All MOVEMENTS</option>
          <option value="last30">LAST 30 MOVEMENTS</option>
          <option value="last20">LAST 20 MOVEMENTS</option>
        </select>
        <component :is="ChevronDown"
                   class="pointer-events-none absolute inset-y-0 top-2 right-2 w-6 h-6 text-primary"/>
      </div>
    </div>

    <!-- Table -->
    <div class="mx-auto">
      <div class="overflow-x-auto bg-white p-4 rounded-lg border border-gray-300">
        <table class="min-w-full divide-y divide-gray-200 ">
          <thead class="bg-white">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">ID</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Oper. Date</th>
            <!--            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Value Date</th>-->
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Receiver</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Type</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Doc. No.</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Description</th>
            <th class="px-4 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Value</th>
            <th class="px-4 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Av. Balance</th>
            <th class="px-4 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Status</th>
            <th v-if="user?.user_type==='corporate'" class="px-2 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Stages</th>
            <th class="relative px-4 py-2"><span class="sr-only">Actions</span></th>
          </tr>
          </thead>

          <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(item, idx) in filteredMovements" :key="idx"
              :class="[idx % 2 === 0 ? 'bg-white' : 'bg-gray-50','hover:bg-gray-100 transition-colors']">
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ item.id }}</td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ item.oper_date }}</td>
            <!--            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ item.value_date }}</td>-->
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
              {{ item.beneficiary ? item.beneficiary.name : "-" }}
            </td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
              {{ TRANSACTION_TYPE_LABELS[item.transaction_type] || item.transaction_type }}
            </td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
              <div class="flex items-center space-x-2">
              <span
                  class="cursor-pointer truncate"
                  @click="copyDocNo(item.doc_no)"
                  :title="item.doc_no">
                {{ formatDocNo(item.doc_no) }}
              </span>
                <button
                    class="p-1 hover:text-gray-900 text-gray-400"
                    @click="copyDocNo(item.doc_no)"
                    title="Copy full doc no"
                    v-if="item.doc_no">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                       viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2"/>
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16 8h2a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2"/>
                  </svg>
                </button>
              </div>
            </td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ item.description }}</td>
            <td
                :class="[
                  'px-4 py-2 whitespace-nowrap text-sm font-semibold text-right',
                  item.transaction_type === TRANSACTION_TYPE.TYPE_CREDIT ? 'text-green-600'
                    : (item.transaction_type === TRANSACTION_TYPE.TYPE_DEBIT || item.transaction_type?.includes('Transfer') || item.transaction_type?.includes('transfer'))?
                     'text-red-600' : 'text-gray-600']">
              {{ formatNumber(item.value) }} {{ item.currency }}
            </td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700 text-right">
              {{formatNumber(item.balance)}}
            </td>

            <td
                :class="['px-4 py-2 whitespace-nowrap text-sm font-semibold text-right',
                (item.status === TRANSACTION_STATUS.STATUS_SETTLED || item.status === TRANSACTION_STATUS.STATUS_APPROVED || item.status === TRANSACTION_STATUS.STATUS_APPROVED) ? 'text-green-600' :
                item.status === TRANSACTION_STATUS.STATUS_REJECTED  ? 'text-red-600' :
                item.status === TRANSACTION_STATUS.STATUS_IN_REVIEW? 'text-yellow-600':
                item.status === TRANSACTION_STATUS.STATUS_PROCESSING? 'text-yellow-700':
                item.status === TRANSACTION_STATUS.STATUS_PENDING  ? 'text-yellow-500' : 'text-gray-600']">
              {{ item.status }}
            </td>


            <td v-if="user?.user_type==='corporate'" class="px-4 py-2 whitespace-nowrap flex justify-center text-center text-gray-700">
              <component
                  v-if="(item.transaction_type===TRANSACTION_TYPE.TYPE_SEPA_TRANSFER || item.transaction_type===TRANSACTION_TYPE.TYPE_SWIFT_TRANSFER)"
                  :is="Workflow"
                  alt=""
                  class="w-5 h-5 mb-2 cursor-pointer justify-center align-middle"
                  @click="openStagesModal(item)"
              />
              <span v-else>-</span>
            </td>

            <td class="px-4 py-2 whitespace-nowrap text-right text-gray-700 cursor-pointer hover:text-orange-600">
              <component :is="FilePlus" class="w-5 h-5 mb-2"
                         @click="openModal(item.id)"/>
            </td>
          </tr>

          <!-- اگر حرکت مالی وجود نداشت -->
          <tr v-if="filteredMovements.length === 0">
            <td colspan="7" class="text-center py-4 text-gray-500">No movements available.</td>
          </tr>

          </tbody>
        </table>
      </div>

      <div class="flex justify-center gap-x-2 mt-6">
        <button @click="exportToExcel" type="submit"
                class="flex items-center justify-center bg-primary font-medium text-white px-8 py-3 rounded-lg shadow">
          VIEW IN EXCEL
        </button>
        <button @click="exportToPDF" type="submit"
                class="flex items-center justify-center bg-primary font-medium text-white px-8 py-3 rounded-lg shadow">
          DOWNLOAD PDF
        </button>
      </div>
    </div>

    <!-- Modal -->
    <TransactionModal
        :isOpen="isModalOpen"
        :transaction="selectedTransaction"
        :account="account"
        @close="isModalOpen = false"
    />

    <TransactionStagesModal
        v-if="selectedStagesTransaction"
        :show="isStagesModalOpen"
        :movement-id="selectedStagesTransaction.id"
        :movement-status="selectedStagesTransaction.status"
        :movement-type="selectedStagesTransaction.transaction_type"
        @close="closeTracking"
    />

  </div>
</template>

<script setup>
import {ref, watch, computed, defineProps, onMounted} from 'vue'
import {ChevronDown, FilePlus,Workflow} from 'lucide-vue-next'
import TransactionModal from "@/components/view/TransactionModal.vue"
import XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {formatNumber} from "@/utils/number";
import {TRANSACTION_STATUS, TRANSACTION_TYPE, TRANSACTION_TYPE_LABELS} from "@/constants/transactions";
import TransactionStagesModal from "@/components/view/TransactionStagesModal.vue";


const props = defineProps({
  account: Object
})

const selectedFilter = ref('all')
const movements = ref([])

const isModalOpen = ref(false)
const selectedTransaction = ref({})

const selectedStagesTransaction = ref({});
const isStagesModalOpen = ref(false);


let user = ref(null)

function openStagesModal(transaction) {
  isStagesModalOpen.value = true;
  selectedStagesTransaction.value = transaction;
}

const closeTracking = () => {
  isStagesModalOpen.value = false
  selectedStagesTransaction.value = null
}



const formatDocNo = (docNo) => {
  if (!docNo) return ''
  const len = docNo.length
  if (len <= 10) return docNo
  return `${docNo.slice(0, 4)}...${docNo.slice(-4)}`
}

const copyDocNo = (docNo) => {
  navigator.clipboard.writeText(docNo)
      .then(() => {
        console.log('Copied:', docNo)
        // میتونی Toast یا alert هم نمایش بدی
      })
      .catch(err => console.error('Failed to copy:', err))
}

function openModal(transactionId) {
  // پیدا کردن تراکنش از props.account.movements اصلی
  const transaction = props.account?.movements?.find(m => m.id === transactionId)
  if (transaction) {
    selectedTransaction.value = {...transaction} // یک کپی جدا بساز
    isModalOpen.value = true
  }
}

watch(() => props.account, (newAccount) => {
  if (newAccount?.movements) {
    movements.value = newAccount.movements.map(m => ({
      id: m.id,
      oper_date: formatDate(m.oper_date),
      value_date: formatDate(m.value_date),
      transaction_type: m.transaction_type,
      status: m.status,
      doc_no: m.doc_no,
      description: m.description,
      value: m.value,
      balance: m.balance
    }))
  } else {
    movements.value = []
  }
}, {immediate: true})

const filteredMovements = computed(() => {
  if (selectedFilter.value === 'last30') return movements.value.slice(0, 30)
  if (selectedFilter.value === 'last20') return movements.value.slice(0, 20)
  return movements.value
})

function exportToExcel() {
  if (!movements.value.length || !props.account) return;

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([]);

  // رنگ‌ها
  const primaryColor = {rgb: 'F16008'}; // نارنجی
  // const secondaryColor = { rgb: 'F5F5F5' }; // خاکی روشن
  const boxBgColor = {rgb: 'FFF5F0'}; // باکس روشن
  const textColor = {rgb: '000000'}; // سیاه

  // اطلاعات حساب (2 ردیفی)
  const accountInfo = [
    ['Account Name', props.account.account_name],
    ['Account Number', props.account.account_number],
    ['Accounting Balance', props.account.accounting_balance],
    ['Available Balance', props.account.available_balance]
  ];

  // افزودن اطلاعات حساب به شیت
  XLSX.utils.sheet_add_aoa(ws, accountInfo, {origin: 0});

  // استایل‌دهی به ردیف‌های اطلاعات حساب
  accountInfo.forEach((row, i) => {
    const labelCell = `A${i + 1}`;
    const valueCell = `B${i + 1}`;

    ws[labelCell].s = {
      font: {bold: true, color: {rgb: 'FFFFFF'}},
      fill: {fgColor: primaryColor},
      alignment: {vertical: 'center', horizontal: 'center'}
    };

    ws[valueCell].s = {
      font: {bold: false, color: textColor},
      fill: {fgColor: boxBgColor},
      alignment: {vertical: 'center', horizontal: 'center'}
    };
  });

  // افزودن یک ردیف خالی بعد از اطلاعات حساب
  XLSX.utils.sheet_add_aoa(ws, [[]], {origin: accountInfo.length});

  // جدول تراکنش‌ها
  const movementHeader = ['Oper. Date', 'Value Date', 'Doc. No.', 'Description', 'Value', 'Balance'];
  XLSX.utils.sheet_add_aoa(ws, [movementHeader], {origin: accountInfo.length + 1});

  const movementsData = movements.value.map(m => [
    m.oper_date,
    m.value_date,
    m.doc_no,
    m.description,
    m.value,
    m.balance
  ]);

  XLSX.utils.sheet_add_aoa(ws, movementsData, {origin: accountInfo.length + 2});

  // استایل‌دهی به هدر جدول
  movementHeader.forEach((_, i) => {
    const cell = XLSX.utils.encode_cell({r: accountInfo.length + 1, c: i});
    if (!ws[cell]) return;
    ws[cell].s = {
      font: {bold: true, color: {rgb: 'FFFFFF'}},
      fill: {fgColor: primaryColor},
      alignment: {vertical: 'center', horizontal: 'center'}
    };
  });

  // رنگ‌دهی به مقادیر Value و Balance
  movementsData.forEach((row, rIdx) => {
    const valueCell = XLSX.utils.encode_cell({r: accountInfo.length + 2 + rIdx, c: 4});
    if (!ws[valueCell]) return;
    ws[valueCell].s = {
      font: {color: {rgb: row[4].includes('-') ? 'DC2626' : '16A34A'}, bold: true},
      alignment: {horizontal: 'right'}
    };

    // راست‌چین کردن Balance
    const balanceCell = XLSX.utils.encode_cell({r: accountInfo.length + 2 + rIdx, c: 5});
    if (ws[balanceCell]) ws[balanceCell].s = {alignment: {horizontal: 'right'}};
  });

  // -------------------------
  // تنظیم عرض ستون‌ها
  // -------------------------
  ws['!cols'] = [
    {wch: 15}, // Oper. Date
    {wch: 15}, // Value Date
    {wch: 15}, // Doc No.
    {wch: 40}, // Description
    {wch: 15}, // Value
    {wch: 15}  // Balance
  ];

  // افزودن شیت به ورک‌بوک
  XLSX.utils.book_append_sheet(wb, ws, 'Movements');

  // ذخیره فایل Excel
  XLSX.writeFile(wb, 'movements.xlsx');
}


function exportToPDF() {
  if (!props.account) return;

  const doc = new jsPDF("p", "mm", "a4");

  // 🎨 رنگ‌ها
  const primaryColor = [241, 96, 8]; // نارنجی #F16008
  const secondaryColor = [245, 245, 245]; // راه‌راه جدول
  const boxBgColor = [255, 250, 245]; // باکس اطلاعات حساب

  const boxX = 14;
  const boxWidth = 182;
  const boxHeight = 24;
  const colWidth = boxWidth / 2;

  const drawHeader = (docInstance) => {
    docInstance.setFillColor(...primaryColor);
    docInstance.rect(0, 0, 210, 20, "F");
    docInstance.setFontSize(18);
    docInstance.setTextColor(255);
    docInstance.setFont("helvetica", "bold");
    docInstance.text("Bison Account Statement", 14, 14);
  };

  const drawFooter = (docInstance) => {
    const pageHeight = docInstance.internal.pageSize.height;
    docInstance.setFontSize(9);
    docInstance.setTextColor(100);
    docInstance.text(`Generated on: ${new Date().toLocaleString()}`, 14, pageHeight - 10);
    docInstance.text("© 2025 Bison Account. All rights reserved.", 120, pageHeight - 10);
  };

  // -------------------------
  // باکس اطلاعات حساب فقط صفحه اول
  // -------------------------
  doc.setFillColor(...boxBgColor);
  doc.setDrawColor(...primaryColor);
  doc.setLineWidth(0.4);
  doc.roundedRect(boxX, 24, boxWidth, boxHeight, 2, 2, 'FD');

  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);

  const row1Y = 32;
  doc.setFont("helvetica", "bold");
  doc.text("Account Name:", boxX + 2, row1Y);
  doc.setFont("helvetica", "normal");
  doc.text(`${props.account.account_name || '-'}`, boxX + colWidth - 2, row1Y, {align: "right"});

  doc.setFont("helvetica", "bold");
  doc.text("Account Number:", boxX + colWidth + 2, row1Y);
  doc.setFont("helvetica", "normal");
  doc.text(`${props.account.account_number || '-'}`, boxX + boxWidth - 2, row1Y, {align: "right"});

  const row2Y = 44;
  doc.setFont("helvetica", "bold");
  doc.text("Accounting Balance:", boxX + 2, row2Y);
  doc.setFont("helvetica", "normal");
  doc.text(`${formatNumber(props.account.accounting_balance) ?? '0.00'}`, boxX + colWidth - 2, row2Y, {align: "right"});

  doc.setFont("helvetica", "bold");
  doc.text("Available Balance:", boxX + colWidth + 2, row2Y);
  doc.setFont("helvetica", "normal");
  doc.text(`${formatNumber(props.account.available_balance) ?? '0.00'}`, boxX + boxWidth - 2, row2Y, {align: "right"});

  // -------------------------
  // جدول تراکنش‌ها
  // -------------------------
  const movementsData = (props.account.movements || []).map(m => [
    formatDate(m.oper_date),
    formatDate(m.value_date),
    m.doc_no,
    m.description,
    m.transaction_type,
    formatNumber(m.value),
    m.beneficiary ? m.beneficiary.name : "-",
    formatNumber(m.balance),
    m.status,
  ]);

  autoTable(doc, {
    head: [["Oper. Date", "Value Date", "Doc. No.", "Description", "Transaction Type", "Value", "Receiver", "Balance", "Status"]],
    body: movementsData,
    startY: 55,
    theme: "grid",
    headStyles: {
      fillColor: primaryColor,
      textColor: 255,
      halign: "center",
      fontSize: 9,
      fontStyle: "bold"
    },
    bodyStyles: {fontSize: 8, valign: 'middle'},
    alternateRowStyles: {fillColor: secondaryColor},
    columnStyles: {
      0: {halign: "center"},
      1: {halign: "center"},
      2: {halign: "center"},
      3: {halign: "left"},
      4: {halign: "left"},
      5: {halign: "right"},
      6: {halign: "center"},
      7: {halign: "right"},
      8: {halign: "right"},
    },
    didParseCell: (data) => {
      if (data.column.index === 5 && data.cell.section === "body") {
        const movement = props.account.movements[data.row.index];
        if (movement.transaction_type?.toLowerCase().includes("transfer") ||
            movement.transaction_type?.toLowerCase() === "debit") data.cell.styles.textColor = [220, 38, 38];
        else if (movement.transaction_type?.toLowerCase() === "credit") data.cell.styles.textColor = [22, 163, 74];
        else data.cell.styles.textColor = [55, 65, 81];
      }
      if (data.column.index === 8 && data.cell.section === "body") {
        const movement = props.account.movements[data.row.index];
        if (movement.status?.toLowerCase().includes("rejected")) data.cell.styles.textColor = [220, 38, 38];
        else if (["approved", "settled"].includes(movement.status?.toLowerCase())) data.cell.styles.textColor = [22, 163, 74];
        else if (movement.status?.toLowerCase() === "pending") data.cell.styles.textColor = [185, 83, 0];
      }
      if ([0, 1, 2].includes(data.column.index) && data.cell.section === "body") data.cell.styles.fontSize = 6;
    },
    margin: {left: 14, right: 14, top: 30},
    didDrawPage: (data) => {
      drawHeader(doc);
      drawFooter(doc);

      if (data.pageNumber > 1) {
        // اضافه کردن فاصله اضافی از بالا
        // توجه: data.cursor.y اشاره به مکان فعلی دارد
        data.cursor.y += 30;
      }
    }
  });

  doc.save("movements.pdf");
}


function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr; // اگر تاریخ معتبر نبود همون رشته خام رو برگردون
  return d.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit"
  });
}

watch(() => props.account, (newAccount) => {
  if (newAccount?.movements) {
    movements.value = newAccount.movements.map(m => ({
      ...m,
      oper_date: formatDate(m.oper_date),
      value_date: formatDate(m.value_date)
    }))
  } else {
    movements.value = [];
  }
}, {immediate: true})


onMounted(async()=>{
  const storedUser = localStorage.getItem('user')

  if (storedUser) {
    user.value = JSON.parse(storedUser)
  }
})

</script>
